import { Injectable } from '@angular/core';
import { HttpService } from '../../providers/http.service';
import { AppConfig } from '../../app/app.config';
@Injectable()
export class WeixinService {
    constructor(
        private httpService: HttpService,
    ) {

    }
    public localStorageSet(key: string, value: any) {
        if (value) {
            value = JSON.stringify(value);
        }
        localStorage.setItem(key, value);
    }
    public localStorageGet<T>(key: string): T {
        let value: string = localStorage.getItem(key);
        if (value && value != "undefined" && value != "null") {
            return <T>JSON.parse(value);
        }

        return null;
    }
    // 本地存储
    // public localStorageGet(key: string) {
    //     return localStorage.getItem(key);
    // }
    // public localStorageSet(key: string, value: any) {
    //     localStorage.setItem(key, value);
    // }
    public SetUnionid(data) {
        this.localStorageSet('wx_Unionid', data);
    }
    public GetUnionid() {
        let unionid = this.localStorageGet('wx_Unionid');
        if (unionid === 'null' || typeof (unionid) === 'undefined') {
            return null;
        }
        return unionid;
    }
    public SetWxSettings(data) {
        // debugger;
        // const json = JSON.stringify(data);
        this.localStorageSet('WechatSetting', data);
    }
    public GetWxSettings() {
        return this.localStorageGet('WechatSetting');
        // if (data == null || data === undefined) {
        //     data = '';
        // }
        // let dataInfo = this.strToObj(data);
        // if (dataInfo == null || dataInfo === undefined) {
        //     dataInfo = '';
        // }
        // return dataInfo;
    }
    // 或去url携带的参数
    // public getParam(paramName) {
    //     let paramValue = '', isFound = !1;
    //     if (this.location.search.indexOf("?") == 0 && this.location.search.indexOf("=") > 1) {
    //         arrSource = unescape(this.location.search).substring(1,
    //  this.location.search.length).split("&"), i = 0;
    //         while (i < arrSource.length && !isFound) arrSource[i].indexOf("=") > 0 &&
    // arrSource[i].split("=")[0].toLowerCase() == paramName.toLowerCase() &&
    // (paramValue = arrSource[i].split("=")[1], isFound = !0), i++
    //     }
    //     return paramValue == "" && (paramValue = null), paramValue
    // }
    public strToObj(json) {
        try {
            let obj = JSON.parse(json);
            if (obj === undefined || obj == null) {
                obj = {};
            }
            return obj;
        } catch (e) {
            return '';
        }
    }
    // 获取后台配置内容
    public GetWxSettingsHideAppsecret() {
        let url = AppConfig.GetProdUrl() + '/System/GetWxSettings';
        return this.httpService.get(url);
    }
    // 微信授权登录 必须微信浏览器发起的请求
    public GetWxAuthbyClient(param: any) {
        let url = AppConfig.GetProdUrl() + '/Wx/WxOAuthLogin';
        return this.httpService.get(url, param);
    }
    // 获取微信unionid
    public GetWxUnionid(param: any) {
        let url = AppConfig.GetProdUrl() + '/Wx/GetWxUnionid';
        return this.httpService.get(url, param);
    }
    // 微信注册
    public WxRegisterUser(code: string, state: string) {
        let url = AppConfig.GetProdUrl() + '/Wx/WxRegisterUser?code=' + code + '&state=' + state;
        return this.httpService.post(url, '');
    }
    // 微信pc扫码绑定授权信息 必须微信浏览器发起的请求
    public BindWxOAuthInfo(param: any) {
        let url = AppConfig.GetProdUrl() + '/Wx/BindWxOAuthInfo';
        return this.httpService.get(url, param);
    }
    // 根据用户名绑定微信unionid 返回1代表成功 必须微信浏览器发起的请求
    public BindingWxUnionid(param: any) {
        let url = AppConfig.GetProdUrl() + '/Wx/BindingWxUnionid';
        return this.httpService.get(url, param);
    }
    // 解绑微信 返回1代表成功 必须微信浏览器发起的请求
    public WxUntie(param: any) {
        let url = AppConfig.GetProdUrl() + '/Wx/WxUntie';
        return this.httpService.get(url, param);
    }
    // 获取pc扫码登录授权code 返回小于0的数据代表 防刷码 同一 ip 10分钟内只能请求30次
    public GetWxOAuthLoginCode() {
        let url = AppConfig.GetProdUrl() + '/Wx/GetWxOAuthLoginCode';
        return this.httpService.get(url);
    }
    // 检查WxOAuthLogin.Id是否绑定且有效 pc检查
    public CheckWxOAuth(id: string) {
        let url = AppConfig.GetProdUrl() + '/Wx/CheckWxOAuth/' + id;
        return this.httpService.get(url);
    }
    // 根据username判断是否已经绑定微信 1绑定 需要登录
    public UserIsBindingWx(param: any) {
        let url = AppConfig.GetProdUrl() + '/Wx/UserIsBindingWx';
        return this.httpService.get(url, param);
    }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/app/weixin/weixin.service.ts